// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"2586354d","254":"2586354d","315":"77c1ff80","400":"2586354d","611":"2586354d","706":"88ba7235","731":"0937a8b1"}[chunkId] + ".chunk.css";
};